import React, { Component } from "react";
import styled from "styled-components";

import { FormControlLabel, Switch } from "@material-ui/core";

import { $, _ } from "js/vendor";
import { UIPane, UIPaneContents } from "js/react/components/UiComponents";
import { FlexSpacer, Gap10 } from "js/react/components/Gap";
import { getStaticUrl, appVersion } from "js/config";
import { FlexBox } from "js/react/components/LayoutGrid";
import { SlideGalleryPreviewThumbnail } from "js/react/views/AddSlide/Panes/SlideGalleryPane";
import { SlideTemplateThumbnail } from "js/react/views/AddSlide/Panes/SlideTemplatesPane";
import { SearchPreview, SearchPreviewHeader } from "js/react/views/AddSlide/Panes/SearchSlidesPane";
import { themeColors } from "js/react/sharedStyles";
import { ThumbnailGrid } from "js/react/views/AddSlide/Panes/Components/ThumbnailGrid";
import Spinner from "js/react/components/Spinner";
import { gallerySlidesDataService } from "js/react/views/AddSlide/DataServices";
import { getCanvasBundle } from "js/canvas";
import log from "js/core/logger";

import { SlideSearchPreview } from "./Components/SlideSearchPreview";

const InfoBar = styled.div`
    margin: 20px 0 20px 0;
    background: white;
    padding: 10px 20px;
    display: flex;
    img {
      height: 90px;
    }
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #333;
`;

const Description = styled.div`
  font-size: 14px;
  color: #555;
`;

const UseBlankTemplate = styled.div.attrs(() => ({
    // Used for identifying the div in cypress tests
    "data-id": "blank_template",
    "style": { "--aspect-ratio": "2" }
}))`
  background: white;
  color: ${themeColors.ui_blue};
  border: solid 3px ${themeColors.ui_blue};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
  padding: 30px;
  &::before {
    content: "";
    display: inline-block;
    width: 1px;
    height: 0;
    padding-bottom: calc(100% / (var(--aspect-ratio)));
  }
`;

export class TemplateInfoPane extends Component {
    state = {
        isLoaded: false,
        gallerySlides: null,
        moreIdeasSlides: null
    }

    componentDidMount() {
        this.loadData();

        $(".thumbnail-grid").prepend();
    }

    async loadData() {
        const { template } = this.props;

        if (window.FORCE_NEW_SLIDES_VERSION) {
            log.info(`[TemplateInfoPane] loadData() forcing new slide version ${window.FORCE_NEW_SLIDES_VERSION}`);
        }

        let [gallerySlides, moreIdeasSlides, { slideTemplates }] = await Promise.all([
            gallerySlidesDataService.search({ templateId: template.id, size: 50 }),
            gallerySlidesDataService.search({ fullTextSearchQuery: template.title, size: 50 }),
            getCanvasBundle(window.FORCE_NEW_SLIDES_VERSION ?? appVersion)
        ]);
        // Explude duplicates
        moreIdeasSlides = moreIdeasSlides.filter(({ id }) => !gallerySlides.some(slide => slide.id === id));

        this.classicTemplates = slideTemplates.classicTemplates;

        this.setState({
            gallerySlides,
            moreIdeasSlides,
            isLoaded: true,
        });
    }

    renderAuthoringTemplates() {
        const templates = this.classicTemplates.map(template => ({ ...template, showPreview: false }));

        return (<div>
            <SearchPreview>
                <SearchPreviewHeader style={{ marginBottom: 15 }}>Quick Start Classic Slides</SearchPreviewHeader>
                <ThumbnailGrid
                    columns={5}
                    colGap={1}
                    rowGap={10}
                    items={templates}
                    thumbnailClass={SlideTemplateThumbnail}
                    onItemSelected={this.props.onClassicTemplateSelected}
                />
            </SearchPreview>
        </div>);
    }

    render() {
        const {
            template,
            hideUseCurrentThemeSwitch,
            onToggleUserTheme,
            showUserTheme,
            onGallerySlideSelected
        } = this.props;
        const {
            moreIdeasSlides,
            gallerySlides,
            isLoaded
        } = this.state;

        const isAuthoring = template.id === "authoring";
        const preview = isAuthoring
            ? <img src={getStaticUrl("/images/classic-slides-preview.gif")} />
            : <img src={getStaticUrl(`/images/template-icons/${template.icon}.svg`)} />;

        if (!isLoaded) {
            return <UIPane><Spinner /></UIPane>;
        }

        return (
            <UIPane>
                <UIPaneContents style={{ paddingRight: 10, paddingBottom: 0 }}>
                    <div className="add-slide-info-bar" >
                        <InfoBar>
                            <FlexBox left>
                                {preview}

                                <div>
                                    <Title>{template.title}</Title>
                                    <Gap10 />
                                    <Description>{template.description}</Description>
                                </div>
                            </FlexBox>

                            <FlexSpacer />

                            {!hideUseCurrentThemeSwitch &&
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={showUserTheme}
                                            onChange={onToggleUserTheme}
                                            color="primary"
                                        />
                                    }
                                    label="Preview with current theme"
                                />
                            }

                        </InfoBar>
                    </div>
                    <div className="search-results-frame">
                        {isAuthoring && this.renderAuthoringTemplates()}

                        {!isAuthoring && (
                            <>
                                <SlideSearchPreview
                                    thumbnail={SlideGalleryPreviewThumbnail}
                                    showUserTheme={showUserTheme}
                                    hideUseCurrentThemeSwitch={hideUseCurrentThemeSwitch}
                                    onSelected={onGallerySlideSelected}
                                    items={gallerySlides?.length ? gallerySlides : []}
                                    thumbnailClass={SlideGalleryPreviewThumbnail}
                                    firstItem={
                                        <UseBlankTemplate onClick={() => this.props.onTemplateSelected(template)}>Start with a <br />Blank Template</UseBlankTemplate>
                                    }
                                    showThemeThumbnails={showUserTheme}
                                />

                                <SlideSearchPreview
                                    title="More Ideas"
                                    thumbnail={SlideGalleryPreviewThumbnail}
                                    showUserTheme={showUserTheme}
                                    hideUseCurrentThemeSwitch={hideUseCurrentThemeSwitch}
                                    onSelected={onGallerySlideSelected}
                                    items={moreIdeasSlides}
                                    thumbnailClass={SlideGalleryPreviewThumbnail}
                                    showThemeThumbnails={showUserTheme}
                                />
                            </>
                        )}
                    </div>
                </UIPaneContents>
            </UIPane>
        );
    }
}

